export function generateWeeks(numberOfWeeks: number) {
  const weeks = Array.from({ length: numberOfWeeks }, (_, index) => ({
    name: `Week ${index + 1}`,
    weekName: "Week",
    label: index + 1,
  }));
  return weeks;
}
